import { toast } from "sonner";
import { api, errMsg, inr } from "@/lib/api";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

function receiptHtml({ clinic, transaction: t, patient, treatment, balance }) {
  const refund = t.type === "refund";
  const due = balance.outstanding;
  return `<html><head><title>${esc(t.receipt_no || "Receipt")}</title><style>
  body{font-family:Manrope,Arial,sans-serif;color:#21171b;max-width:640px;margin:30px auto;padding:0 24px}
  .top{display:flex;justify-content:space-between;border-bottom:3px solid #762c39;padding-bottom:16px}
  h1{margin:0;color:#762c39;font-size:24px}.muted{color:#806f73;font-size:12px;line-height:1.6}
  .tag{background:#f0b429;color:#55202d;font-weight:700;padding:6px 10px;border-radius:4px;font-size:12px;height:max-content}
  table{width:100%;border-collapse:collapse;margin:22px 0}td{padding:9px 0;border-bottom:1px solid #eadfe0;font-size:14px}td:last-child{text-align:right}
  .amt{font-size:30px;font-weight:800;color:#762c39;margin:10px 0}.bal{background:#faf0e8;padding:14px;border-radius:6px;display:flex;justify-content:space-between;font-weight:700}
  .foot{margin-top:30px;font-size:12px;color:#806f73;text-align:center}.sign{margin-top:50px;text-align:right;font-size:12px;color:#806f73}
  </style></head><body>
  <div class="top"><div style="display:flex;align-items:center;gap:14px">${clinic.logo_data_url ? `<img src="${clinic.logo_data_url}" style="width:60px;height:60px;object-fit:contain"/>` : ""}<div><h1>${esc(clinic.name)}</h1><div class="muted">${esc(clinic.address)}${clinic.phone ? `<br/>Phone: ${esc(clinic.phone)}` : ""}${clinic.email ? ` · ${esc(clinic.email)}` : ""}${clinic.registration_no ? `<br/>Reg. no: ${esc(clinic.registration_no)}` : ""}</div></div></div>
  <div class="tag">${refund ? "REFUND VOUCHER" : "PAYMENT RECEIPT"}</div></div>
  <table>
    <tr><td>Receipt no.</td><td><b>${esc(t.receipt_no || "—")}</b></td></tr>
    <tr><td>Date</td><td>${esc(t.date)}</td></tr>
    <tr><td>Patient</td><td>${esc(patient?.name)} (${esc(patient?.opd)})</td></tr>
    ${treatment ? `<tr><td>For</td><td>${esc(treatment.treatment)}${treatment.tooth ? ` · tooth ${esc(treatment.tooth)}` : ""}</td></tr>` : ""}
    <tr><td>Mode</td><td>${esc(t.method)}</td></tr>
    ${t.notes ? `<tr><td>Notes</td><td>${esc(t.notes)}</td></tr>` : ""}
  </table>
  <div class="muted">${refund ? "Amount refunded to patient" : "Amount received"}</div>
  <div class="amt">${inr(t.amount)}</div>
  <table>
    <tr><td>Agreed treatment cost</td><td>${inr(balance.treatment_total)}</td></tr>
    <tr><td>Total paid</td><td>${inr(balance.payments)}</td></tr>
    ${balance.discounts ? `<tr><td>Discounts</td><td>− ${inr(balance.discounts)}</td></tr>` : ""}
    ${balance.refunds ? `<tr><td>Refunds</td><td>${inr(balance.refunds)}</td></tr>` : ""}
  </table>
  <div class="bal"><span>${due < 0 ? "Advance in credit" : "Remaining balance"}</span><span>${inr(Math.abs(due))}</span></div>
  <div class="muted" style="margin-top:6px">Balance as on ${new Date().toLocaleDateString("en-IN")}.</div>
  <div class="sign">Authorised signatory<br/><br/>____________________</div>
  <div class="foot">${esc(clinic.receipt_footer)}</div>
  </body></html>`;
}

export async function printReceipt(id) {
  const w = window.open("", "_blank");
  if (!w) return toast.error("Allow pop-ups to print the receipt");
  w.document.write("<p style='font-family:sans-serif;padding:30px'>Preparing receipt…</p>");
  try {
    const r = await api.get(`/payments/${id}/receipt`);
    w.document.open(); w.document.write(receiptHtml(r.data)); w.document.close();
    setTimeout(() => w.print(), 300);
  } catch (e) {
    w.close(); toast.error(errMsg(e, "Could not prepare the receipt"));
  }
}
